module.exports = __webpack_public_path__ + "static/media/ZSCE_MF_TROCA.3699c982.pdf";